import React from "react";
import { Button, Dialog } from "tvs-unified-lib/dist";
import { DialogActions, DialogMessage, DialogTitle } from "./styles";

export interface DialogAction {
  id: string;
  label: string;
  onClick: () => void;
  variant?: "primary" | "secondary" | "outline" | "ghost" | "danger";
  size?: "sm" | "md" | "lg";
  disabled?: boolean;
}

interface Props {
  title?: string;
  content: React.ReactNode;
  actions: DialogAction[];
  size?: "sm" | "md" | "lg";
  open: boolean;
  onClose: () => void;
  dialogProps?: Omit<React.ComponentProps<typeof Dialog>, "size" | "children">;
}

const ConfirmationDialog = ({
  title,
  content,
  actions,
  size = "sm",
  open,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onClose,
  dialogProps,
}: Props) => {
  if (!open) {
    return null;
  }

  return (
    <Dialog size={size} {...dialogProps}>
      {title && <DialogTitle>{title}</DialogTitle>}

      {typeof content === "string" ? (
        <DialogMessage>{content}</DialogMessage>
      ) : (
        content
      )}

      {actions && actions.length > 0 && (
        <DialogActions>
          {actions.map(
            ({
              id,
              label,
              onClick,
              variant = "primary",
              size: buttonSize = "md",
              ...rest
            }) => (
              <Button
                key={id}
                label={label}
                variant={variant as "outline" | "block" | "no-border"}
                size={buttonSize}
                onClick={onClick}
                {...rest}
              />
            )
          )}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default ConfirmationDialog;
